import { useState, FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { onboardingApi } from '../api/client'
import { Button, Card, Field, Input } from '../components/ui'

export default function ForgotPasswordPage() {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    if (loading) return
    setLoading(true)
    try {
      await onboardingApi.forgotPassword(email)
    } catch {
      // Always show success to avoid email enumeration
    } finally {
      setLoading(false)
      setSubmitted(true)
    }
  }

  if (submitted) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="w-full max-w-sm text-center">
          <Card padded={false} className="p-8">
            <div className="w-12 h-12 bg-brand-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h2 className="text-lg font-bold text-gray-900 mb-2">{t('forgotPassword.sentTitle')}</h2>
            <p className="text-sm text-gray-500 mb-6">{t('forgotPassword.sentHint')}</p>
            <Link to="/login" className="text-sm text-brand-600 hover:text-brand-700 font-medium">
              {t('forgotPassword.backToLogin')}
            </Link>
          </Card>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-gray-900">{t('forgotPassword.title')}</h1>
          <p className="text-gray-500 text-sm mt-1">{t('forgotPassword.subtitle')}</p>
        </div>

        <Card>
          <form onSubmit={handleSubmit} className="space-y-4">
            <Field label={t('forgotPassword.email')}>
              {(p) => (
                <Input
                  {...p}
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  placeholder={t('forgotPassword.emailPlaceholder')}
                />
              )}
            </Field>

            <Button type="submit" loading={loading} fullWidth>
              {loading ? t('forgotPassword.submitting') : t('forgotPassword.submit')}
            </Button>
          </form>
        </Card>

        <p className="text-center text-sm text-gray-500 mt-4">
          <Link to="/login" className="text-brand-600 hover:text-brand-700 font-medium">
            {t('forgotPassword.backToLogin')}
          </Link>
        </p>
      </div>
    </div>
  )
}
